import { border } from '@atlaskit/adf-schema';
export var borderPlugin = function borderPlugin() {
  return {
    name: 'border',
    marks: function marks() {
      return [{
        name: 'border',
        mark: border
      }];
    }
  };
};